/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import {useAppSelector} from "@/app/hooks/redux";
import {TCmsPageAllStoresData} from "@/app/types/prefetchedData/cmsPageData";

const  getCurrentStoreCmsPageData  = (cmsPageData:TCmsPageAllStoresData) => {
    const {currentStore} = useAppSelector(state => state.storeConfigReducer);
    return  cmsPageData.stores[currentStore as string]
}

export default getCurrentStoreCmsPageData